import React from 'react';

const SettingsIcon = ({ className }) => (
  <svg className={className} viewBox="-4 -4 24 24">
    <g>
      <path d="M14.75 7L16.25 7 16.5 10 14.5 10z" />
      <path d="M0.75 7L2.25 7 2.5 10 0.5 10z" />
      <path d="M7.75 0L9.25 0 9.5 3 7.5 3z" />
      <path d="M7.75 14L9.25 14 9.5 17 7.5 17z" />
      <path d="M12.7 2.05L14.2 2.05 14.45 5.05 12.45 5.05z" />
      <path d="M2.8 11.95L4.3 11.95 4.55 14.95 2.55 14.95z" />
      <path d="M2.8 2.05L4.3 2.05 4.55 5.05 2.55 5.05z" />
      <path d="M12.7 11.95L14.2 11.95 14.45 14.95 12.45 14.95z" />
      <path d="M15.5 8.389c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7zm-2 0c0-2.762-2.239-5-5-5s-5 2.238-5 5c0 2.761 2.239 5 5 5s5-2.239 5-5z" />
    </g>
  </svg>
);

export default SettingsIcon;
